<template>
    <v-menu
      ref="menu"
      v-model="menu"
      :close-on-content-click="false"
      :nudge-right="40"
      :return-value.sync="modelValue"
      transition="scale-transition"
      offset-y
      min-width="auto"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-model="internalValue"
          :label="field.label"
          :required="field.is_required"
          readonly
          v-bind="attrs"
          v-on="on"
          outlined
          dense
        ></v-text-field>
      </template>
      <v-date-picker 
        v-model="internalValue" 
        @input="updateValue" 
        @close="menu = false"
      ></v-date-picker>
    </v-menu>
  </template>
  
  <script>
  export default {
    props: {
      modelValue: String,
      field: Object,
    },
    emits: ['update:modelValue'],
    data() {
      return {
        menu: false,
        internalValue: this.modelValue,
      };
    },
    watch: {
      modelValue(newValue) {
        this.internalValue = newValue;
      }
    },
    methods: {
      updateValue(value) {
        // this.$emit('update:modelValue', value);
        this.$emit('custom-update', value);
        this.menu = false;
      }
    }
  };
  </script>
  
  
  
  
  